<wiz-vgroup #vgDetailZone width="100%" height="100%" class="section-container-parent" padding="5px">
  <wiz-vgroup width="100%" class="section-container" padding="5px">
    <wiz-label [wizLabel]="'$.widget.chart.type.$'" class="smallTitleLabel"></wiz-label>
      <wiz-dropdown
        #ddlType
        wizValidator
        [wizDataProvider]="charTypeDS"
        [wizLabelField]="'code'"
        [wizMandatory]="true"
        wizShowLabel="false"
        width="200px"
      ></wiz-dropdown>
  </wiz-vgroup>

  <wiz-vgroup #detailGP width="100%" height="100%" style="overflow: auto !important"><!-- zone principale, scrollable -->

    <wiz-hgroup #dataGP width="100%" height="250px" style="padding-bottom: 3px">
      <wiz-vgroup width="100%" height="100%" class="section-container">
        <wiz-label [wizLabel]="'$.widget.chart.edit.field.$'" class="smallTitleLabel"></wiz-label>
        <wiz-tile-list
          #fieldList
          id="fieldList"
          width="100%"
          height="100%"
          itemHeight="30"
          itemWidth="160"
          [wizDataProvider]="fieldFreeDS"
          [wizItemRenderer]="renderer"
          [dragEnabled]="true"></wiz-tile-list>
      </wiz-vgroup>

      <wiz-vgroup width="180px" height="100%" class="section-container">
        <wiz-label [wizLabel]="'$.widget.chart.edit.keys.$'" class="smallTitleLabel"></wiz-label>
        <wiz-list
        #lstRow
        width="180px"
        height="100%"
        [wizLabelField]="'label'"
        [wizItemRenderer]="renderer"
        [dragEnabled]="true"
        [dropEnabled]="true"
        [dragMove]="true"
      ></wiz-list>
      <wiz-dropdown
        #ddColorField *ngIf="useColorField"
        [wizDataProvider]="colorDS"
        width="100%"
        [wizLabelField]="'trsLabel'"
        [wizLabel]="'$.widget.chart.colorfield.$'"
        width="100%"
      ></wiz-dropdown>

      </wiz-vgroup>
    </wiz-hgroup><!-- fin dataGp-->

    
    <wiz-hgroup #measureGP width="100%" height="250px" style="padding-bottom: 3px">
      <!-- les mesures dispos -->
      <wiz-vgroup width="100%" height="100%" class="section-container">
        <wiz-label
        [wizLabel]="'$.widget.chart.edit.measure.$'"
        width="100%"
        class="smallTitleLabel"></wiz-label>
        <wiz-tile-list
        #measureList
        id="measureList"
        width="100%"
        height="100%"
        itemHeight="30"
        itemWidth="160"
        [wizDataProvider]="measureFreeDS"
        [wizItemRenderer]="renderer"
        [dragEnabled]="true"></wiz-tile-list>
      <filter-component #measureFreeFilter></filter-component>
      </wiz-vgroup>

      <!-- axe X -->
      <wiz-vgroup [visible]="needXDatas" width="180px" height="100%" padding="3px" class="section-container">
        <wiz-label [wizLabel]="'$.widget.chart.edit.xaxis.$'" class="smallTitleLabel"></wiz-label>
        <wiz-list
          #lstColumn
          id="lstColumn"
          width="100%"
          height="100%"
          [wizLabelField]="'label'"
          [wizItemRenderer]="renderer"
          [dragEnabled]="true"
          [dropEnabled]="true"
          [dragMove]="true"
        ></wiz-list>
      </wiz-vgroup>

      <wiz-vgroup width="180px" height="100%" padding="3px" class="section-container">
        <wiz-label [wizLabel]="'$.widget.chart.edit.yaxis.$'" class="smallTitleLabel"></wiz-label>
        <wiz-list
          #lstData
          id="lstData"
          width="100%"
          height="100%"
          [wizLabelField]="'label'"
          [wizItemRenderer]="renderer"
          [dragEnabled]="true"
          [dropEnabled]="true"
          [dragMove]="true"
        ></wiz-list>
      </wiz-vgroup>
    </wiz-hgroup>

    <wiz-vgroup #paramsGP width="100%" class="section-container" padding="5px">
      <wiz-label [wizLabel]="'$.widget.chart.params.$'" class="smallTitleLabel"></wiz-label>
      <ng-container #paramsContainer></ng-container>
    </wiz-vgroup>
  </wiz-vgroup>

   <wiz-hgroup width="100%" [horizontalAlign]="'end'" verticalAlign="center" class="section-container">
     <wiz-button
      #btnSave
      (click)="doValid()"
      [wizLabel]="'$.common.save.modification.$'"
      [wizIcon]="'icon-arrow-right'"
      [iconPlacement]="'right'"
      [wizDisabled]="!isValidable"
    ></wiz-button>
    <wiz-button
      #btnCancel
      (click)="doCancel()"
      class="cancel-button"
      [wizIcon]="'icon-arrow-left'"
      [wizLabel]="'$.common.cancel.modification.$'"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
